import pgwyClient from "@/api/pgwyClient";

const Procedures = {
  state: {
    procedures: null
  },
  mutations: {
    setProcedures(state, procedures) {
      state.procedures = procedures;
    }
  },
  actions: {
    async updateProcedures({ commit, state }) {

      if (!state.procedures) {
        const procedures = (await Promise.all((await pgwyClient.getProcedures()).data.procedures
            .map((procedure)=> pgwyClient.getProcedureDetails(procedure.procid))))
            .map((response) => response.data.procedure);

        commit("setProcedures", procedures);
      }

      return state.procedures;
    }
  },
};

export default Procedures;
